<opac-dialog [open]="open()">
  <h3 slot="header">{{ 'user.details.changePasswordTitle' | translate }}</h3>
  <div opacAutoFocusError class="form" [formGroup]="form">
    <opac-password-input
      formControlName="newPassword"
      [invalid]="newPasswordControl | invalidControl"
      [required]="true">
      {{ 'user.details.newPassword' | translate }}

      <span *ngIf="newPasswordControl | invalidControl" slot="error">
        <span *ngIf="newPasswordControl.hasError('password') && !newPasswordControl.hasError('required')"
          >{{ 'login.passwordFormat' | translate }}</span
        >
        <span *ngIf="newPasswordControl.hasError('required')">{{ 'signup.errors.required' | translate }}</span>
      </span>
    </opac-password-input>

    <opac-password-input
      formControlName="confirmPassword"
      [invalid]="confirmPasswordControl | invalidControl"
      [required]="true">
      {{ 'user.fields.confirmPassword' | translate }}

      <span *ngIf="confirmPasswordControl | invalidControl" slot="error">
        <span *ngIf="confirmPasswordControl.hasError('confirmPassword') && !confirmPasswordControl.hasError('required')"
          >{{ 'login.passwordNotMatching' | translate }}</span
        >
        <span *ngIf="confirmPasswordControl.hasError('required')">{{ 'signup.errors.required' | translate }}</span>
      </span>
    </opac-password-input>
  </div>

  <div slot="actions">
    <opac-button (click)="validatePasswords()"> {{ 'user.details.changePasswordTitle' | translate }} </opac-button>
  </div>
</opac-dialog>
